module.exports = __webpack_public_path__ + "static/media/not.2e50276f.svg";